import React from 'react';
import withIcon from '../utilities/withIcon';

const IconParagraph = () => {
  return (
    <g>
      <path d="M11.75 0c.05 0 .098.005.145.014l2.354.005a.75.75 0 0 1 .1 1.493l-.102.007-1.747-.004V15.25a.75.75 0 1 1-1.5 0V8.994H8.5v6.256a.75.75 0 1 1-1.5 0V8.994H5.497A4.497 4.497 0 0 1 1 4.497 4.492 4.492 0 0 1 5.28.011l.218-.005 2.139.002a.756.756 0 0 1 .227 0l3.743.006A.754.754 0 0 1 11.75 0zM11 1.513l-2.5-.004v5.985H11V1.513zm-5.504-.007A2.992 2.992 0 0 0 2.5 4.497c0 1.596 1.247 2.901 2.82 2.992l.177.005H7V1.507l-1.504-.001z" />
    </g>
  );
};

export default withIcon(IconParagraph);
